module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0116.a6ff80fc.jpg";